// @noflow
import isClient from 'Common/app/isClient';

let _isFetching = false;
let _shouldRefresh = false;
let _lastHash = '';

class Heartbeat {
  constructor() {
    if (!Heartbeat.instance) {
      if (isClient) {
        this.onHeartbeatInterval();
        this.heartbeatInterval = setInterval(this.onHeartbeatInterval, 5 * 60 * 1000);
      }
      Heartbeat.instance = this;
    }
    return Heartbeat.instance;
  }

  onHeartbeatInterval = () => {
    if (_isFetching) {
      return;
    }
    _isFetching = true;
    fetch('/health/heartbeat')
      .then(response => {
        _isFetching = false;
        return response.json();
      })
      .then(res => {
        _shouldRefresh = _shouldRefresh || (_lastHash && _lastHash !== res.danyone);
        _lastHash = res.danyone;
      });
  };

  shouldRefresh = () => _shouldRefresh;
}

// singleton
const instance = process.env.IN_CHROMECAST_MODE
  ? {} /* No need in 'heartbeating functionality' in Chromecast mode */
  : new Heartbeat();
Object.freeze(instance);

export default instance;
